import { SearchOutlined } from "@ant-design/icons";
import { Col, Input, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import LastUserSearchs from "./LastUserSearchs";
import SearchSuggestion from "./SearchSuggestion";
import { RootState } from "store/Reducers";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { handleSetAdvertListFilter } from "apps/RealState/ListItems/ClientStates";

const Search = () => {
  const [isShowSearchHistories, setIsShowSearchHistories] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const { filter } = useSelector((state: RootState) => state.realState);
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const searchRef = useRef<HTMLDivElement | null>(null);

  // Dış tıklamaları dinle
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setIsShowSearchHistories(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Debounce edilen arama kelimesini güncelle
  const updateSearchTerm = useDebouncedCallback((value: string) => {
    setDebouncedSearchTerm(value);
  }, 500);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    updateSearchTerm(e.target.value);
  };

  const handleSearchClick = async () => {
    if (debouncedSearchTerm) {
      const currentFilter = {
        ...filter,
        Title: debouncedSearchTerm,
        IsSearchFilter: true,
      };

      await dispatch(handleSetAdvertListFilter({ filter: currentFilter }));
      setIsShowSearchHistories(false);
      setSearchTerm("");
      navigate("/ilan");
    }
  };

  return (
    <div ref={searchRef} className="!relative w-full">
      <Input
  id="header-search"
  placeholder="Ara"
  className="!w-full !border-[#e3e3e3] !text-xs !bg-[#FFF] shadow !h-[38px] !rounded-2xl"
  value={searchTerm}
  onChange={handleChange}
  onFocus={() => setIsShowSearchHistories(true)}
  onPressEnter={handleSearchClick}  // ← Enter event
  prefix={
    <SearchOutlined
      className="hover:cursor-pointer !text-dark-400 !text-lg pr-3"
      onClick={handleSearchClick}
    />
  }
/>

      {debouncedSearchTerm.length > 2 && isShowSearchHistories && (
        <Col
          xs={24}
          className="!absolute top-[8.5rem] sm:top-10 !z-50 !h-auto !bg-white w-full sm:w-full !shadow-lg !border-[#e3e3e3] !rounded-2xl !overflow-auto left-0 sm:left-auto"
        >
          <Row gutter={[0, 20]}>
            <Col xs={24}>
              <SearchSuggestion
                setSearchTerm={setSearchTerm}
                searchKey={debouncedSearchTerm}
                setSearchKey={setDebouncedSearchTerm}
                setSearchContainerHeight={() => {}}
              />
            </Col>

            {userInfoes && (
              <Col xs={24}>
                <LastUserSearchs setSearchTerm={setSearchTerm} />
              </Col>
            )}
          </Row>
        </Col>
      )}
    </div>
  );
};

export default Search;
